/**
 * Danh sách nguồn tin cậy — DỮ LIỆU, không phải hằng số trong code.
 *
 * Lynust chốt 08/09/2026: *"cho tôi 1 ô input, tôi sẽ insert vào, khi bấm insert thì tự động thêm
 * vào danh sách, khi bấm bỏ thì bỏ ra khỏi danh sách."*
 *
 * Xem .claude/docs/research-standards.md §6bis
 */
/**
 * Chuẩn hoá thứ người gõ vào ô nhập thành một domain.
 *
 * Người sẽ dán cả URL đầy đủ — `https://www.MOH.gov.vn/tin-tuc?a=1` phải thành `moh.gov.vn`.
 * Không chuẩn hoá thì cùng một nguồn vào danh sách ba lần dưới ba hình dạng.
 */
export function chuanHoaDomain(input) {
    let s = (input ?? "").trim().toLowerCase();
    if (s === "")
        throw new Error("Domain rỗng");
    /**
     * ⚠️ **Chỉ `http` và `https`.** Bản đầu (08/09/2026) chỉ cắt giao thức có `//`, nên
     * `mailto:ai@moh.gov.vn` đi lọt: không có `//` ⇒ không cắt ⇒ `split("@").pop()` ra đúng
     * `moh.gov.vn` ⇒ **được nhận là một nguồn tin cậy**. Một địa chỉ email không phải một trang.
     */
    const giaoThuc = s.match(/^([a-z][a-z0-9+.-]*):\/\//);
    if (giaoThuc) {
        if (giaoThuc[1] !== "http" && giaoThuc[1] !== "https") {
            throw new Error(`Chỉ nhận http/https, không nhận "${giaoThuc[1]}:"`);
        }
        s = s.slice(giaoThuc[0].length);
    }
    else {
        // Không được cắt ở dấu hai chấm đầu tiên: `moh.gov.vn:443/abc` cũng có dạng đó, và phần
        // trước nó là TÊN MIỀN. Phân biệt bằng phần sau — cổng thì chỉ có chữ số.
        const m = s.match(/^([a-z][a-z0-9+.-]*):(.*)$/);
        if (m && !/^\d+([/?#].*)?$/.test(m[2] ?? "")) {
            throw new Error(`Không nhận ra domain từ: ${JSON.stringify(input)}`);
        }
    }
    s = s.split("@").pop() ?? ""; // bỏ user:pass@ — TRƯỚC khi cắt đường dẫn
    s = s.split(/[/?#]/)[0] ?? ""; // bỏ đường dẫn, tham số, neo
    s = s.split(":")[0] ?? ""; // bỏ cổng
    s = s.replace(/^www\./, "");
    s = s.replace(/\.+$/, "");
    // Nhãn không được bắt đầu/kết thúc bằng gạch ngang, và nhãn cuối phải là chữ (TLD).
    if (!/^[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)+$/.test(s)) {
        throw new Error(`Không nhận ra domain từ: ${JSON.stringify(input)}`);
    }
    if (!/\.[a-z]{2,}$/.test(s)) {
        throw new Error(`"${s}" không có phần đuôi tên miền hợp lệ`);
    }
    return s;
}
export function themNguon(ds, input, tang, nguoiThem, ngay, ghiChu) {
    let domain;
    try {
        domain = chuanHoaDomain(input);
    }
    catch (e) {
        return { ok: false, lyDo: e.message };
    }
    if (ds.some((m) => m.domain === domain)) {
        return { ok: false, lyDo: `${domain} đã có trong danh sách` };
    }
    return { ok: true, ds: [...ds, { domain, tang, ghiChu, ngayThem: ngay, nguoiThem }], domain };
}
/**
 * Bỏ một domain.
 *
 * ⚠️ Bỏ KHÔNG ảnh hưởng bài đã viết — bài cũ giữ nguyên trích dẫn của nó. Danh sách chỉ áp cho
 * lượt research KẾ TIẾP. Không có luật này thì bỏ một domain làm hàng chục bài cũ trông như
 * thiếu nguồn.
 */
export function boNguon(ds, input) {
    let domain;
    try {
        domain = chuanHoaDomain(input);
    }
    catch (e) {
        return { ok: false, lyDo: e.message };
    }
    if (!ds.some((m) => m.domain === domain)) {
        return { ok: false, lyDo: `${domain} không có trong danh sách` };
    }
    return { ok: true, ds: ds.filter((m) => m.domain !== domain), domain };
}
/** Một URL có thuộc nguồn được phép không. Khớp cả subdomain: `dmec.moh.gov.vn` ⊂ `moh.gov.vn`. */
export function nguonDuocPhep(ds, url) {
    let host;
    try {
        host = chuanHoaDomain(url);
    }
    catch {
        return null;
    }
    /**
     * **Mục cụ thể hơn thắng.** Khai cả `moh.gov.vn` (tầng 1) lẫn `blog.moh.gov.vn` (tầng 5) thì
     * một `find()` trả về mục nào đứng trước trong mảng — tức thứ tự nhập quyết định tầng tin cậy,
     * và một dòng chung chung âm thầm **nâng tầng** của một tên miền con.
     */
    let tot = null;
    for (const m of ds) {
        if (host !== m.domain && !host.endsWith(`.${m.domain}`))
            continue;
        if (tot === null || m.domain.length > tot.domain.length)
            tot = m;
    }
    return tot;
}
/**
 * Danh sách rỗng ⇒ Luồng 3 KHÔNG chạy, và nói rõ lý do.
 * Không âm thầm chấp nhận mọi nguồn — đó là cách tầng X lọt vào.
 */
export function luong3ChayDuoc(ds) {
    return ds.length === 0
        ? { duoc: false, lyDo: "Danh sách nguồn tin cậy đang rỗng — Luồng 3 dừng cho tới khi có ít nhất một nguồn." }
        : { duoc: true };
}
/** Chuẩn hoá mà **không ném** — dùng ở vòng lặp lọc, nơi một URL rác là chuyện bình thường. */
export function thuChuanHoaDomain(input) {
    try {
        return chuanHoaDomain(input);
    }
    catch {
        return null;
    }
}
/**
 * Lọc một mớ URL xuống những cái **được phép trích dẫn**, kèm tầng. Giữ thứ tự, bỏ trùng.
 *
 * Đây là hàng rào tầng X: URL không thuộc danh sách thì **biến mất**, không đi kèm một nhãn
 * "chưa rõ nguồn" để rồi ai đó dùng tạm.
 */
export function locUrlTheoNguon(urls, ds) {
    const ra = [];
    const daCo = new Set();
    for (const u of urls) {
        const s = (u ?? "").trim();
        if (s === "" || daCo.has(s))
            continue;
        const nguon = nguonDuocPhep(ds, s);
        if (nguon === null)
            continue;
        daCo.add(s);
        ra.push({ url: s, nguon });
    }
    return ra;
}
/**
 * Một trích dẫn **đủ trường** hay không — `research-standards.md` §3: url + tên nguồn + ngày
 * truy cập, không thiếu cái nào.
 *
 * Một định nghĩa DUY NHẤT cho chữ "đủ", để màn Nguồn, cửa duyệt và lượt ghi Google Sheet không
 * mỗi chỗ hiểu một kiểu.
 */
export function trichDanDuTruong(t) {
    return ((t.url ?? "").trim() !== "" &&
        (t.tenNguon ?? "").trim() !== "" &&
        (t.ngayTruyCap ?? "").trim() !== "");
}
/**
 * Danh sách khởi đầu **đề xuất** — `research-standards.md` §6bis.
 *
 * ⚠️ Là **gợi ý điền hộ ô nhập**, KHÔNG phải mặc định của hệ. Không dòng code nào tự nạp nó vào
 * `CaiDat`: một danh sách nguồn tự xuất hiện là một danh sách không ai chọn, mà luật 3 của §6bis
 * đòi mỗi mục có người thêm và ngày thêm.
 */
export const GOI_Y_NGUON_KHOI_DAU = [
    { domain: "moh.gov.vn", tang: 1, ghiChu: "Bộ Y tế" },
    { domain: "dmec.moh.gov.vn", tang: 1, ghiChu: "Cổng thông tin trang thiết bị y tế" },
    { domain: "muasamcong.mpi.gov.vn", tang: 1, ghiChu: "Đấu thầu quốc gia" },
    { domain: "who.int", tang: 2, ghiChu: "WHO" },
    { domain: "fda.gov", tang: 2, ghiChu: "FDA — tra 510(k)" },
    { domain: "pubmed.ncbi.nlm.nih.gov", tang: 3, ghiChu: "Tạp chí bình duyệt" },
    { domain: "vjol.info.vn", tang: 3, ghiChu: "Tạp chí khoa học VN" },
    { domain: "laerdal.com", tang: 4, ghiChu: "Trang chính hãng" },
    { domain: "mindray.com", tang: 4, ghiChu: "Trang chính hãng" },
    { domain: "miradry.com", tang: 4, ghiChu: "Trang chính hãng" },
];
/**
 * Nhãn tiếng Việt của năm tầng — `research-standards.md` §1.
 *
 * ⚠️ Ở đây vì **hai màn cạnh nhau đã có hai bản sao viết tay** (10/09/2026): khối ô nhập nguồn
 * và danh sách báo cáo, cùng một trang, mỗi bên một mảng nhãn. Đổi chữ ở một bên thì hai khối
 * dính nhau nói khác nhau về cùng một con số.
 */
export const NHAN_TANG = {
    1: "văn bản nhà nước VN",
    2: "tổ chức y tế quốc tế",
    3: "tạp chí bình duyệt",
    4: "tài liệu hãng",
    5: "báo ngành",
};
/**
 * Nguồn dùng được cho một site — `null`/thiếu nghĩa là **mọi site nghiên cứu**.
 *
 * Viết thành hàm vì phép so `n.site === site` bỏ sót đúng nhóm mục cũ chưa có trường này, và
 * triệu chứng là *"đã khai nguồn rồi mà Luồng 3 vẫn nói không có nguồn"*.
 */
export function nguonChoSite(ds, site) {
    return ds.filter((n) => n.site === null || n.site === undefined || n.site === site);
}
//# sourceMappingURL=nguon.js.map